import recordDetailSession from './record-details/session-store';
import accountCreatePage from './record-details/record-pages/account-create-page-store';
import contactCreatePage from './record-details/record-pages/contact-create-page-store';

export default {
    namespaced: true,
    modules: {
        recordDetailSession,
        accountCreatePage,
        contactCreatePage,
    },
};
